import React from "react"

import { useAppDispatch } from "redux/hooks"
import { makeSignConsent } from "redux/features/consent/consentSignThunk"
import IdCard from "components/Sign/IdCard"
import { ClientIdCardSignResponseValues } from "types"
import { ID_CARD_SIGN_METHOD } from "config"

type Props = {
  consentId: string
  onFailure: () => void
  onSuccess: () => void
}

const IdCardSignComponent = ({ consentId, onFailure, onSuccess }: Props) => {
  const dispatch = useAppDispatch()

  const signObject = {
    type: "Consent",
    id: consentId,
  }

  const handleSubmit = (values: ClientIdCardSignResponseValues) => {
    const { signature, certificate } = values

    const params = {
      consent_id: consentId,
      signing_method: ID_CARD_SIGN_METHOD,
      signature,
      certificate,
    }

    dispatch(makeSignConsent(params))
      .then(() => {
        onSuccess()
      })
      .catch(() => {
        onFailure()
      })
  }

  return <IdCard signObject={signObject} onSubmit={handleSubmit} />
}

export default IdCardSignComponent
